/* --------------------------------工具方法---------------------------------------- */
export const utils = {
   // 获取浏览器上传递地址 getQueryString("startDate")
   getUrlQueryString: function GetQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]); return null;
   },
   // 获取当前日期，格式传入format，eg：- /
   getNowTime: function (format) {
      let now = new Date();
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let day = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");//padStart（）头部补全，padEnd（）尾部补全
      day = day.toString().padStart(2, "0");//padStart（）头部补全，padEnd（）尾部补全
      // console.log(year+"-"+month)
      return year + format + month + format + day
   },
   // 获取往前或者往后某天的日期
   // datt为需要往前或者往后的日期，dayNum为往前或者往后的天数，forwardOrBack为往前或者往后，前为-后为+，format为返回日期格式
   // 格式2020-09-04,n传入天数,format为格式，eg：- /
   getTimes: function (datt, dayNum, forwardOrBack, format) {
      // let datt= this.getNowTime()
      datt = datt.split(format);
      let newDate = new Date(datt[0], datt[1] - 1, datt[2]);
      if (forwardOrBack == "+") {
         let befminuts = newDate.getTime() + 1000 * 60 * 60 * 24 * parseInt(dayNum);//计算前几天用减，计算后几天用加，最后一个就是多少天的数量 n为向前或者向后天数
      } else if (forwardOrBack == "-") {
         let befminuts = newDate.getTime() - 1000 * 60 * 60 * 24 * parseInt(dayNum);//计算前几天用减，计算后几天用加，最后一个就是多少天的数量 n为向前或者向后天数
      }
      let beforeDat = new Date;
      beforeDat.setTime(befminuts);
      let befMonth = beforeDat.getMonth() + 1;
      let mon = befMonth >= 10 ? befMonth : '0' + befMonth;
      let befDate = beforeDat.getDate();
      let da = befDate >= 10 ? befDate : '0' + befDate;
      newDate = beforeDat.getFullYear() + format + mon + format + da;
      return newDate
   },
   // 统一打印数据
   log: function () {
      for (item in arguments) {
         console.log(arguments[item])
      }
   },
   // tryCatch
   tryCatch: function (callBack, catchCallback) {
      try {
         callBack();
      } catch (error) {
         catchCallback();
         utils.log("tryCatch", error);
      }
   },
   // 随机数取值,min,max为最小值和最大值,包含min和max  eg: utils.getRandom(5,7)=>5,6,7
   getRandom: function (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
   },
   //头部自动补全  eg: utils.AutoCompleteStart("test",5,"0")=>0test
   AutoCompleteStart: function (str, length, content) {
      return str.toString().padStart(length, content)
   },
   // 头部自动补全 eg: utils.AutoCompleteEnd("test",5,"0")=>test0
   AutoCompleteEnd: function (str, length, content) {
      return str.toString().padEnd(length, content)
   },
}


// WEBPACK FOOTER //
// ./src/utils/util.js